import React from "react";

/**
 * Inline SVG icons for Capa V2 so the page renders without external assets.
 * Replace with exported Figma SVGs later where higher fidelity is needed.
 */

type IconProps = {
  size?: number;
  color?: string;
  className?: string;
};

// Circular arrow used inside CTA buttons (chevron-up-right style)
export const ArrowIcon: React.FC<IconProps> = ({
  size = 28,
  color = "#FFFFFF",
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M7 17L17 7M17 7H8M17 7V16"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Horizontal arrow used inside the Publico CTA buttons (matches Figma →)
export const ArrowRightIcon: React.FC<IconProps> = ({
  size = 28,
  color = "#FFFFFF",
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M4 12h15M13 6l6 6-6 6"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronRight: React.FC<IconProps> = ({
  size = 24,
  color = "#FFFFFF",
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M9 6l6 6-6 6"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlusIcon: React.FC<IconProps> = ({
  size = 16,
  color = "#373737",
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M12 5v14M5 12h14"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const MinusIcon: React.FC<IconProps> = ({
  size = 16,
  color = "#373737",
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path d="M5 12h14" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const WhatsappIcon: React.FC<IconProps> = ({
  size = 28,
  color = "#644ED0",
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M12 3a9 9 0 0 0-7.7 13.6L3 21l4.5-1.2A9 9 0 1 0 12 3Z"
      stroke={color}
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 8.8c0-.3.3-.6.6-.6h.8c.2 0 .4.1.5.4l.5 1.2c.1.2 0 .4-.1.5l-.5.5c.4.9 1.1 1.6 2 2l.5-.5c.1-.2.3-.2.5-.1l1.2.5c.2.1.4.3.4.5v.8c0 .3-.3.6-.6.6A6.6 6.6 0 0 1 8.5 8.8Z"
      fill={color}
    />
  </svg>
);

export const PeopleIcon: React.FC<IconProps> = ({
  size = 28,
  color = "#644ED0",
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <circle cx="9" cy="8" r="3" stroke={color} strokeWidth="1.6" />
    <circle cx="17" cy="9.5" r="2.2" stroke={color} strokeWidth="1.6" />
    <path
      d="M4 19c0-2.8 2.2-5 5-5s5 2.2 5 5M15 14.5c2 .2 3.5 1.9 3.5 4"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

export const ClockIcon: React.FC<IconProps> = ({
  size = 28,
  color = "#644ED0",
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.6" />
    <path
      d="M12 7v5l3 2"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Closing double quotes used on the Depoimentos cards
export const QuoteIcon: React.FC<IconProps> = ({
  size = 48,
  color = "#644ED0",
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    className={className}
    aria-hidden="true"
  >
    <path d="M14.017 21v-7.391C14.017 7.905 17.748 4.039 23 3l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zM0 21v-7.391C0 7.905 3.748 4.038 9 3l.996 2.151C7.563 6.068 6 8.789 6 11h3.983v10H0z" />
  </svg>
);
